import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { NavLink } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import PropTypes from 'prop-types';

const pages = [
  { name: 'Discord', to: '/discord/dashboard', disabled: false },
  { name: 'Download', to: '/download', disabled: false },
  { name: 'Servers', to: '/servers', disabled: true },
];
const settings = [
  { name: 'Dashboard', to: '/settings/dashboard', disabled: true },
  { name: 'Admin', to: '/admin', disabled: false },
];

function TemporaryNavBar(props) {
  const { loggedIn } = props;
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            component={NavLink}
            to="/"
            variant="h6"
            noWrap
            sx={{
              mr: 2,
              display: {
                color: 'inherit',
                textDecoration: 'inherit',
                xs: 'none',
                md: 'flex',
              },
            }}
          >
            SAMJANDRIS.COM
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  component={NavLink}
                  to={page.to}
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  disabled={page.disabled}
                >
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            component={NavLink}
            to="/"
            variant="h6"
            noWrap
            sx={{
              color: 'inherit',
              textDecoration: 'inherit',
              flexGrow: 1,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            SAMJANDRIS.COM
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                component={NavLink}
                to={page.to}
                key={page.name}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
                disabled={page.disabled}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            {loggedIn ? (
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar
                    alt="Remy Sharp"
                    src={getAuth().currentUser.photoURL}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              <Button
                component={NavLink}
                to="/login"
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                SIGN IN
              </Button>
            )}
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem
                  component={NavLink}
                  to={setting.to}
                  key={setting.name}
                  onClick={handleCloseUserMenu}
                  disabled={setting.disabled}
                >
                  <Typography textAlign="center">{setting.name}</Typography>
                </MenuItem>
              ))}
              <MenuItem
                onClick={() => {
                  signOut(getAuth());
                  handleCloseUserMenu();
                }}
              >
                <Typography textAlign="center">Sign out</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

TemporaryNavBar.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

export default TemporaryNavBar;
